var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGarment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(-582 -5925.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M610.214,5930.647a5.97,5.97,0,0,1,5.431,3.38l3.28,7.068a1.964,1.964,0,0,1-.975,2.6l-5.9,2.827-.262.126v11.813a3.31,3.31,0,0,1-3.375,3.233H595.584a3.31,3.31,0,0,1-3.375-3.233V5946.65l-.263-.126-5.894-2.824a1.964,1.964,0,0,1-.976-2.6l3.28-7.07a5.971,5.971,0,0,1,5.431-3.379h2.358a2.094,2.094,0,0,1,1.909,1.2,4.193,4.193,0,0,0,2.254,2.159,4.434,4.434,0,0,0,1.691.334,4.3,4.3,0,0,0,3.948-2.491,2.086,2.086,0,0,1,1.909-1.2h2.358M602,5935.886a5.92,5.92,0,0,1-5.426-3.417l-.124-.274h-2.663a4.342,4.342,0,0,0-3.952,2.459l-3.283,7.071-.185.4.407.195,4.748,2.272.688.33v-3.665a.809.809,0,0,1,1.616,0v17.209a1.725,1.725,0,0,0,1.759,1.685h12.834a1.725,1.725,0,0,0,1.758-1.685v-17.209a.809.809,0,0,1,1.617,0v3.665l.687-.33,4.749-2.272.406-.195-.184-.4-3.283-7.07a4.343,4.343,0,0,0-3.953-2.46h-2.672l-.124.274a5.763,5.763,0,0,1-3.081,2.952,6.1,6.1,0,0,1-2.339.465",
    fill: "#3d4463"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 40,
    height: 40,
    transform: "translate(582 5925.667)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGarment);
export default __webpack_public_path__ + "static/media/icon-garment.a9816572bc33d6c4c84e55eaa44d963e.svg";
export { ForwardRef as ReactComponent };